// Archivo de secretos locales. Este archivo NO debe comotearse en repositorios públicos.
export const secrets = {
  chatwoot: {
    tokenA3: "T2VkrSdvrrvmMGyMqhtdE6UW",
    tokenA2: "Fb2EQDbzgu6B4xiCuqNDXBnR",
    tokenCIM: "d3zqjy8JfQErP48Bku9TrVED",
    tokenSP: "U2MZkEiq8HrxRJvbiFtWJBXW",
    tokenCEN: "xUvnSFW1BjgTtKVKi2Cp6cpA",
    tokenCIMG: "vspuLEMFmkL94vDpTR7he981"
  }
};
